import { render, staticRenderFns } from "./Shabake.vue?vue&type=template&id=2008bc69"
import script from "./Shabake.vue?vue&type=script&lang=js"
export * from "./Shabake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports